module.exports = __webpack_public_path__ + "static/media/IGCSE_cie_logo.cde3b522.jpg";